import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import swal from "sweetalert";
import { ProtectAPi } from "../../../../api/ProtectAPi";
import AdminQuickNav from "../AdminQuickNav";

const Orderlist = () => {
  const { http } = ProtectAPi();
  const tableRef = useRef(null);
  const dataTableInstance = useRef(null);
  const [tableData, setTableData] = useState([]);

  /* ================= FETCH ORDER LIST ================= */
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await http.get("/order-list");
      const data = res.data?.data || [];
      setTableData(data);
    } catch (error) {
      console.error("Order fetch error:", error);
      setTableData([]);
    }
  };

  /* ================= DATATABLE INIT ================= */
  useEffect(() => {
    $.fn.dataTable.ext.errMode = "none";

    if (dataTableInstance.current) {
      $(dataTableInstance.current).DataTable().destroy();
      dataTableInstance.current = null;
    }

    if (tableData.length > 0) {
      dataTableInstance.current = $(tableRef.current).DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        pageLength: 10,
       
      });
    }

    return () => {
      if (dataTableInstance.current) {
        try {
          $(dataTableInstance.current).DataTable().destroy();
        } catch (e) {}
        dataTableInstance.current = null;
      }
    };
  }, [tableData]);

  /* ================= STATUS BADGE ================= */
  const renderStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return <span className="badge badge-warning">Pending</span>;
      case "confirmed":
        return <span className="badge badge-info">Confirmed</span>;
      case "processing":
        return <span className="badge badge-primary">Processing</span>;
      case "shipped":
        return <span className="badge badge-dark">Shipped</span>;
      case "delivered":
        return <span className="badge badge-success">Delivered</span>;
      case "cancelled":
        return <span className="badge badge-danger">Cancelled</span>;
      default:
        return <span className="badge badge-secondary">N/A</span>;
    }
  };

  return (
    <div className="main-content" style={{ marginTop: -20 }}>
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">

              <AdminQuickNav active="orders" />

              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-3">
                    <h5 className="fw-bold">Order List</h5>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table table-striped table-bordered"
                      ref={tableRef}
                      id="order-table"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Order ID</th>
                          <th>Customer</th>
                          <th>Phone</th>
                          <th>Product</th>
                          <th>Article</th>
                          <th>Qty</th>
                          <th>Total</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {tableData.map((order, index) => (
                          <tr key={order.id}>
                            <td>{index + 1}</td>
                            <th className="fw-bold">
                              {order.order_number}
                            </th>
                            <td>{order.customer_name}</td>
                            <td>{order.phone}</td>
                            <td>{order.product_name}</td>
                            <th>{order.article_number}</th>
                            <td>{order.quantity}</td>
                            <td>{order.total}</td>
                            <td>{renderStatusBadge(order.status)}</td>
                           
                            <td>
                              <div className="d-flex gap-2 justify-content-center">
                                {/* View Button */}
                                <Link
                                  to={`/admin/order-view/${order.id}`}
                                  title="View Order"
                                >
                                <button className="btn mr-1 btn-info btn-md">
                                  <i className="fas fa-eye text-white"></i>
                                </button>
                                </Link>

                                {/* Edit Button */}
                                <Link
                                  to={`/admin/order-edit/${order.id}`}
                                  title="Edit Order"
                                >
                                <button className="btn btn-warning btn-md">
                                  <i className="fas fa-edit text-white"></i>
                                </button>
                                </Link>
                              </div>
                            </td>


                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Orderlist;
